import { render, staticRenderFns } from "./decorateAcceptance.vue?vue&type=template&id=18325974&scoped=true&"
import script from "./decorateAcceptance.vue?vue&type=script&lang=js&"
export * from "./decorateAcceptance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18325974",
  null
  
)

export default component.exports